import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { noticeForError } from '@backrs_ui/grow-ui/src/components/InstitutionWrite/noticeForError';
import { WriteDialog } from '@backrs_ui/grow-ui/src/components/InstitutionWrite/WriteDialog';
import { orMissing } from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/namedRefLabel';
import type { AdminCode } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import { Button, Typography } from '@mui/material';

const { revokeDialog: strings } = appStrings.modules.rostersAdmin;

type RevokeCodeDialogProps = Readonly<{
  open: boolean;
  onClose: () => void;
  /** The line the door was opened from, named in the title. */
  subjectName: string;
  /**
   * The line's own code. Single-target by C2a: the door acts on the code the line SHOWS, so
   * there is nothing to choose and no list that could slide the target after a revoke lands.
   */
  code: AdminCode;
  isSubmitting: boolean;
  isWriteInFlight: boolean;
  isError: boolean;
  errorMessage?: string | null;
  onConfirm: () => void;
}>;

export const RevokeCodeDialog = ({
  open,
  onClose,
  subjectName,
  code,
  isSubmitting,
  isWriteInFlight,
  isError,
  errorMessage,
  onConfirm,
}: RevokeCodeDialogProps) => (
  <WriteDialog
    id="rosters-admin-revoke-dialog"
    open={open}
    onClose={onClose}
    title={strings.title(subjectName)}
    footer={
      <>
        <Button
          id="rosters-admin-revoke-dialog-close"
          hierarchy="Secondary gray"
          size="md"
          onClick={onClose}
        >
          {strings.cancel}
        </Button>
        <Button
          id="rosters-admin-revoke-dialog-submit"
          hierarchy="Primary destructive"
          size="md"
          disabled={isSubmitting || isWriteInFlight}
          onClick={onConfirm}
        >
          {isSubmitting ? strings.submitting : strings.submit}
        </Button>
      </>
    }
  >
    <Typography id="rosters-admin-revoke-dialog-body" variant="text-sm-regular">
      {strings.body(orMissing(code.value))}
    </Typography>
    {isError ? (
      <Typography id="rosters-admin-revoke-dialog-error" variant="text-sm-regular" role="alert">
        {noticeForError(errorMessage, strings.failed)}
      </Typography>
    ) : null}
  </WriteDialog>
);
